import { faCheck, faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons"

import { SpecimenResource, getTranslatedString } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { SpecimenCard, SearchResultItemCard } from '@skinsoft/ui';
import { specimenSelectors } from '@skinsoft/selectors';
import { defineComponent } from 'vue';


export const ContainerSpecimenCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSearchResultItemCard: SearchResultItemCard,
        sSpecimenCard: SpecimenCard,
    },
    props: ['specimen', 'canDelete'],
    template: require('./container-specimen-card.html'),
    data() {
        return {
            futureLocation: '',
            deleting: false,
            isBeingDeletedId: '',   // when item changes the component is not recreated and keep old values
                                    // sometimes the change event is triggered when the item is still the same
                                    // so we keep id of the item in isBeingDeleted state to know if we keep or not the state

            checkIcon: faCheck,
            crossIcon: faTimes,
            spinnerIcon: faCircleNotch,
        }
    },
    computed: {
        isBeingDeleted: {
            get(): boolean {
                if (this.specimen && this.isBeingDeletedId) {
                    let id = (this.specimen as SpecimenResource).id ?? ''

                    return this.isBeingDeletedId === id
                }

                return false
            },
            set(value: boolean) {
                if (value) {
                    let id = (this.specimen as SpecimenResource).id ?? ''

                    this.isBeingDeletedId = id
                } else {
                    this.isBeingDeletedId = ''
                }
            },
        },
    },
    mounted() {
        this.getFutureLocation()
    },
    methods: {
        getFutureLocation() {
            if (this.specimen) {
                const location = specimenSelectors.futureLocation(this.specimen)
                if (location) {
                    // @ts-ignore
                    this.futureLocation = getTranslatedString(location.path, this.getAppLocale())
                } else {
                    this.futureLocation = ''
                }
            }
        },

        onLongPress() {
            if (this.canDelete) {
                this.isBeingDeleted = !this.isBeingDeleted
            }
        },

        onDelete() {
            this.deleting = true
            this.$emit('delete', this.specimen)
        },

        onCancelDelete() {
            this.isBeingDeleted = false
        },
    },
    watch: {
        specimen: {
            handler() {
                if (this.specimen) {
                    this.getFutureLocation()
                }
            },
            immediate: true,
            deep: true,
        },
    },
})
